import { FC, PropsWithChildren } from 'react';
import { useAtomValue } from 'jotai';
import useCustomWindowMessageEvent from 'src/hooks/useCustomWindowMessageEvent';
import useSessionAccess from 'src/hooks/useSessionAccess';
import { nextPagePropsAtom } from 'src/stores/pageProps/atoms';
import MainAppWrapper from './MainAppWrapper';
const WebClientWrapper: FC<PropsWithChildren> = ({
  children
}) => {
  const pageProps = useAtomValue(nextPagePropsAtom);
  useCustomWindowMessageEvent();
  useSessionAccess();
  if (pageProps?.isIncidental) {
    return <>{children}</>;
  }
  return <MainAppWrapper data-sentry-element="MainAppWrapper" data-sentry-component="WebClientWrapper" data-sentry-source-file="index.tsx">{children}</MainAppWrapper>;
};
export default WebClientWrapper;